import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IDynamicFormValidation } from 'src/app/core/interfaces/shared/IDynamicFormValidation';
import { FieldConfig, FxFlexSizesConfig, Validator } from './dynamic-form-config.interface';

@Injectable({
  providedIn: 'root'
})
export class DynamicFormService {

  constructor(
    private translateService: TranslateService
  ) { }

  generateField(name: string, label: string, type: string, placeholder: string, value?: any, width: string = "100%",
    validations: IDynamicFormValidation[] = [], opts: any = {}): FieldConfig {
    return {
      name: name,
      type: type,
      label: placeholder,
      value: value,
      spanLabel: label,
      fxFlex: this.generate_fx_flex(),
      matFormFieldWidth: width,
      validations: validations,
      ...opts
    }
  }

  private generate_fx_flex(): FxFlexSizesConfig {
    return {
      xs: 'calc(60% - 20px)',
      sm: 'calc(40% - 20px)',
      md: '40',
      gtMd: '100'
    }
  }

  generateRequiredValidation(translateKey: string, inputName?: string): Validator {
    let key = '';
    if(inputName) {
      key = translateKey + `.input.${inputName}.validations.required`;
    }else{
      key = translateKey + `.validations.required`;
    }
    
    const message = this.translateService.instant(key) as string;

    return {
      name: "required",
      validator: Validators.required,
      message: message
    };
  }
}
